export default "__VITE_ASSET__kyVhAiAw__"